import api from '../../../api/index';

export default {
  getPosts({ rootGetters, commit }, userId) {
    return api.get(`/api/journal/users/${userId}/get-team-posts`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getConstructions({ rootGetters, commit }, userId) {
    return api.get(`/api/journal/users/${userId}/constructions`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  createNewConstruction({ rootGetters, commit }, { userId, data }) {
    return api.post(`/api/journal/users/${userId}/constructions`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getUserConstructionsPosts({ rootGetters }, { userId }) {
    return api.get(`/api/journal/users/${userId}/get-all-posts`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getPostByID({ rootGetters }, { userId, constructionId, postId }) {
    return api.get(
      `/api/journal/users/${userId}/constructions/${constructionId}/posts/${postId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  getConstructionByID({ rootGetters }, { userId, constructionId }) {
    return api.get(
      `/api/journal/users/${userId}/constructions/${constructionId}`,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  updateConstructionByID({ rootGetters }, { userId, constructionId, data }) {
    return api.put(
      `/api/journal/users/${userId}/constructions/${constructionId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  createTeam({ rootGetters }, userId, teamData) {
    return api.post(`api/journal/users/${userId}/teams`, teamData, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getTeams({ rootGetters }, userId) {
    return api.get(`/api/journal/users/${userId}/teams`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  getTeamByID({ rootGetters }, { userId, teamId }) {
    return api.get(`/api/journal/users/${userId}/teams/${teamId}`, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  updateTeamByID({ rootGetters }, { userId, teamId, data }) {
    return api.put(`/api/journal/users/${userId}/teams/${teamId}`, data, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  addMember({ rootGetters }, { userId, teamId, data }) {
    return api.post(
      `api/journal/users/${userId}/teams/${teamId}/add-member`,
      data,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
  removeMember({ rootGetters }, { userId, teamId, removedMemberId }) {
    return api.delete(
      `api/journal/users/${userId}/teams/${teamId}/remove-member/${removedMemberId}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${rootGetters.getToken}`,
        },
      }
    );
  },
};
